/* rx-design-stage.js — comportement du bloc de présentation d'un design signature.
   RxDesignStage(wrapEl) : gère le choix du support (liens, prix, nom) et la barre CTA mobile.
   stage.show(design) : affiche un autre design (utilisé par la galerie). */
(function () {
  if (window.RxDesignStage) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function RxDesignStage(wrap) {
    var self = this;
    this.wrap = wrap;
    var q = function (s) { return wrap.querySelector(s); };
    this.stage = q('[data-rxs]');
    this.media = q('.rxs__media');
    this.title = q('[data-rxs-title]');
    this.style = q('[data-rxs-style]');
    this.price = q('[data-rxs-price]');
    this.supBox = q('.rxs__supports');
    this.supList = q('[data-rxs-supports]');
    this.supName = q('[data-rxs-supname]');
    this.colorNote = q('[data-rxs-colornote]');
    this.cta = q('[data-rxs-cta]');
    this.bar = q('[data-rxs-bar]');
    this.barImg = q('[data-rxs-bar-img]');
    this.barCta = q('[data-rxs-bar-cta]');

    this.supList.addEventListener('click', function (e) {
      var b = e.target.closest('.rxs__sup');
      if (b) self.pick(b);
    });

    var checked = this.supList.querySelector('[aria-checked="true"]') || this.supList.querySelector('.rxs__sup');
    if (checked) this.pick(checked);

    if ('IntersectionObserver' in window && this.bar) {
      new IntersectionObserver(function (entries) {
        var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        self.bar.classList.toggle('is-visible', off);
        self.bar.setAttribute('aria-hidden', off ? 'false' : 'true');
        self.barCta.tabIndex = off ? 0 : -1;
      }).observe(this.cta);
    }
  }

  RxDesignStage.prototype.pick = function (btn) {
    Array.prototype.forEach.call(this.supList.children, function (b) {
      b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
    });
    var url = btn.getAttribute('data-url');
    if (url) { this.cta.href = url; if (this.barCta) this.barCta.href = url; }
    this.supName.textContent = btn.getAttribute('data-name') || '';
    this.price.textContent = btn.getAttribute('data-price') || '';
    if (this.colorNote) this.colorNote.hidden = btn.getAttribute('data-current') === 'true';
  };

  RxDesignStage.prototype.swapImage = function (src, alt) {
    var media = this.media;
    var img = new Image();
    img.className = 'rxs__img' + (reduce ? '' : ' rxs__img--incoming');
    img.alt = alt; img.width = 1100; img.height = 1100; img.decoding = 'async';
    img.src = src;
    var mount = function () {
      media.appendChild(img);
      var finished = false;
      var done = function () {
        if (finished) return; finished = true;
        media.querySelectorAll('.rxs__img').forEach(function (el) {
          if (el !== img && !el.classList.contains('rxs__img--incoming')) el.remove();
        });
        img.classList.remove('rxs__img--incoming');
      };
      if (reduce) done(); else { img.addEventListener('animationend', done, { once: true }); setTimeout(done, 700); }
    };
    if (img.decode) img.decode().then(mount, mount); else img.onload = mount;
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  RxDesignStage.prototype.show = function (d) {
    this.swapImage(d.img, d.title);
    this.title.textContent = d.title;
    this.style.textContent = d.style || '';
    this.stage.setAttribute('aria-label', d.title);
    if (this.barImg && d.imgBar) this.barImg.src = d.imgBar;
    if (!reduce) {
      [this.title, this.style.parentNode].forEach(function (el) {
        el.classList.remove('rxs-fade'); void el.offsetWidth; el.classList.add('rxs-fade');
      });
    }
    var html = '';
    d.supports.forEach(function (s) {
      html += '<button type="button" class="rxs__sup" role="radio" aria-checked="' + (s.current ? 'true' : 'false') + '"' +
        ' aria-label="' + esc(s.name + ' · ' + s.price) + '" title="' + esc(s.name) + '"' +
        ' data-name="' + esc(s.name) + '" data-price="' + esc(s.price) + '" data-url="' + esc(s.url) + '" data-current="' + (s.current ? 'true' : 'false') + '">' +
        (s.thumb ? '<img src="' + esc(s.thumb) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="rxs__sup-text">' + esc(s.name.slice(0, 3)) + '</span>') +
        '</button>';
    });
    this.supList.innerHTML = html;
    this.supBox.hidden = d.supports.length < 2;
    var btn = this.supList.querySelector('[aria-checked="true"]') || this.supList.querySelector('.rxs__sup');
    if (btn) this.pick(btn);
    else { this.cta.href = d.link; if (this.barCta) this.barCta.href = d.link; this.price.textContent = ''; this.supName.textContent = ''; }
  };

  window.RxDesignStage = RxDesignStage;

  // Pages design : initialisation automatique des blocs autonomes
  function autoInit() {
    document.querySelectorAll('.rxs-wrap[data-rxs-auto]').forEach(function (w) {
      if (!w.__rxs) w.__rxs = new RxDesignStage(w);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoInit);
  else autoInit();
})();